var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Instant } from '@js-joda/core';
import { useFetchPromise } from '@rad/hooks';
import { useNotify } from '@rad/contexts/notifications';
import { fetchPerformers } from '../../http/invoices';
import { fetchInspectionTemplates, fetchInspectionsByInvoice, startInspection } from '../../http/inspections';
import { formatDate } from '../../utility/formatters';
import CModal from './modal';
import Button from './button';
import CSelect from './select';
export default (props) => {
    const notify = useNotify();
    const [performers] = useFetchPromise(fetchPerformers(props.merchantId));
    const [templates] = useFetchPromise(fetchInspectionTemplates);
    const [items, setItems] = React.useState(null);
    const [selectedPerformerId, setSelectedPerformerId] = React.useState(null);
    const [selectedTemplateId, setSelectedTemplateId] = React.useState(null);
    const [starting, setStarting] = React.useState(false);
    const [error, setError] = React.useState(false);
    const reload = React.useCallback(() => {
        if (!props.invoiceId) {
            return;
        }
        setItems(null);
        setError(false);
        fetchInspectionsByInvoice(props.invoiceId, {
            'success': (data) => setItems(data),
            'error': () => setError(true),
        });
    }, [props.invoiceId]);
    React.useEffect(() => {
        if (!props.visible || !props.invoiceId) {
            return;
        }
        reload();
    }, [props.visible, props.invoiceId, reload]);
    const createInspection = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!props.invoiceId || !selectedPerformerId || starting) {
            return;
        }
        try {
            setStarting(true);
            yield startInspection(props.invoiceId, selectedPerformerId, selectedTemplateId);
            setSelectedPerformerId(null);
            notify({ 'message': 'Inspection created successfully', 'kind': 'success' });
            reload();
        }
        finally {
            setStarting(false);
        }
    });
    return _jsxs(CModal, { visible: props.visible, title: "Inspections", onClose: props.onClose, nofooter: true, lg: true, children: [error && _jsx("p", { className: "text-danger", children: "Failed to load inspections." }), !error && items === null && _jsx("p", { className: "text-muted", children: "Loading..." }), !error && items !== null && _jsxs(_Fragment, { children: [_jsxs("table", { className: "table table-sm", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Title" }), _jsx("th", { children: "Date" }), _jsx("th", { children: "Status" }), _jsx("th", { children: "Technician" })] }) }), !!items.length && _jsx("tbody", { children: items.map((x) => _jsxs("tr", { children: [_jsx("td", { children: _jsx("a", { href: `#/inspections/${x.id}`, onClick: () => props.onClose(), children: x.title }) }), _jsx("td", { children: formatDate(Instant.parse(x.created)) }), _jsx("td", { children: x.completed === null
                                                ? _jsx("span", { className: "badge bg-warning text-dark", children: "In Progress" })
                                                : _jsx("span", { className: "badge bg-success", children: "Completed" }) }), _jsx("td", { children: x.performer_name })] }, x.id)) }), !items.length && _jsx("tfoot", { children: _jsx("tr", { children: _jsx("td", { colSpan: 4, className: "text-center text-muted", children: "No inspections for this repair order yet." }) }) })] }), _jsxs("div", { className: "d-flex justify-content-center align-items-center gap-2 mt-3", children: [_jsx("div", { style: { 'minWidth': '220px' }, children: _jsx(CSelect, { small: true, inline: true, value: selectedTemplateId, onChange: setSelectedTemplateId, items: templates || [], valuef: (x) => x.id, titlef: (x) => x.name, emptyValue: "", emptyTitle: "Standard Inspection", disabled: starting, children: "Template" }) }), _jsx("div", { style: { 'minWidth': '220px' }, children: _jsx(CSelect, { small: true, inline: true, value: selectedPerformerId, onChange: setSelectedPerformerId, items: (performers || (() => []))(), valuef: (x) => x.id, titlef: (x) => x.name, emptyTitle: "Select Performer", disabled: starting, children: "Performer" }) }), _jsx(Button, { color: "success", onClick: createInspection, disabled: !selectedPerformerId || starting, children: starting ? 'Creating...' : '+ Start New Inspection' })] })] })] });
};
